import { CurrentNumberAction } from '../actions/CurrentNumberAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
    requestBody: {
        sectionId: "CurrentNumber",
        steps: [
            {
                sequence: "0",
                offerContainerId: "",
                stepId: "",
                fields: [
                    {
                        name: "Number",
                        value: ""
                    }
                ]
            }
        ],
    },
    getCustomerDetailsData: {},
    initiateOTPSwapResponse: {},
    ivrCallbackStatusResponse: {},
    validateOTPSwapResponse: {},
    rSendOTPSwapResponse: {},
    formData: {}
}

const CurrentNumberReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    // var NumberValue = { ...state.requestBody.steps };

    switch (type) {
        case CurrentNumberAction.CURRENT_NUMBER_SELECTION:
            let numberValueData: any = {};
            if (payload.stepId === "SIMServicesCurrentNumber") {
                numberValueData =
                {
                    sectionId: "CurrentNumber",
                    steps: [
                        {
                            sequence: "0",
                            offerContainerId: payload.offerContainerId,
                            stepId: payload.stepId,
                            fields: [
                                {
                                    name: "Number",
                                    value: payload?.phoneNumber
                                },
                                {
                                    name: "IDNumber",
                                    value: payload?.getCustomerDetailsResponse?.IDNumber
                                },
                                {
                                    name: "Nationality",
                                    value: payload?.getCustomerDetailsResponse?.NationalityString
                                },
                                {
                                    name: "NewStack",
                                    value: payload?.getCustomerDetailsResponse?.NewStack ? payload.getCustomerDetailsResponse.NewStack : 'N'
                                },
                                {
                                    name: "OldSIMNumber",
                                    value: payload?.getCustomerDetailsResponse?.SIMNumber
                                },
                                {
                                    name: "OldIMSI",
                                    value: payload?.getCustomerDetailsResponse?.IMSI
                                },
                                {
                                    name: "PackageType",
                                    value: payload?.getCustomerDetailsResponse?.Plan
                                },
                                {
                                    name: "SimswapOTP",
                                    value: payload?.otpVal
                                }
                            ],
                            options: [
                                {
                                    name: "IDName",
                                    value: payload?.getCustomerDetailsResponse?.IDDocTypeString
                                }
                            ]
                        }
                    ],
                }

            } else {
                numberValueData = {
                    sectionId: "CurrentNumber",
                    steps: [
                        {
                            sequence: "0",
                            offerContainerId: payload.offerContainerId,
                            stepId: payload.stepId,
                            fields: [
                                {
                                    name: "Number",
                                    value: payload?.phoneNumber
                                }
                            ]
                        }
                    ],
                }
            }
            // NumberValue[0].stepId = payload.stepId;
            // NumberValue[0].fields[0].value = payload.phoneNumber;
            // NumberValue[0].offerContainerId = payload.offerContainerId;
            return {...state, requestBody: numberValueData};
        
        case CurrentNumberAction.UPDATE_FORM_DATA:
            return { ...state, formData: payload }

        case CurrentNumberAction.GET_CUSTOMER_DETAILS_SUCCESS:
            return { ...state, getCustomerDetailsData: payload }
        case CurrentNumberAction.SIMSWAP_CEM_OTP_INITIATE_SUCCESS:
            return { ...state, initiateOTPSwapResponse: payload };
        case CurrentNumberAction.IVR_CALL_BACK_STATUS_SUCCESS:
            return { ...state, ivrCallbackStatusResponse: payload };
    
            case CurrentNumberAction.SIMSWAP_CEM_OTP_VALIDATE_SUCCESS:
                return { ...state, validateOTPSwapResponse: payload };
    
            case CurrentNumberAction.SIMSWAP_CEM_OTP_RSEND_SUCCESS:
                return { ...state, rSendOTPSwapResponse: payload };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let numberValueRes: any = {
                sectionId: "CurrentNumber",
                steps: [
                    {
                        sequence: "0",
                        offerContainerId: "",
                        stepId: "",
                        fields: [
                            {
                                name: "Number",
                                value: ""
                            }
                        ]
                    }
                ],
            };
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'CurrentNumber')
            });
            if (section.length > 0) {
                // NumberValue[0].offerContainerId = section[0].steps[0].offerContainerId;
                // if(section[0].steps[0].stepId === "SIMServicesCurrentNumber") {
                //     let nationalityType = section[0].steps[0].options[0];
                //     NumberValue[0].options[0].value = nationalityType ? nationalityType.value : "";
                // }
                // NumberValue[0].stepId = section[0].steps[0].stepId;
                // for (let i = 0; i < NumberValue[0].fields.length; i++) {
                //     const currDate = section[0].steps[0].fields.filter((field: any) => { return (field.name === NumberValue[0].fields[i].name) })[0];
                //     NumberValue[0].fields[i].value = currDate ? currDate.value : "";
                // }
                if (section[0].steps[0].stepId === "SIMServicesCurrentNumber") {
                    numberValueRes =
                    {
                        sectionId: "CurrentNumber",
                        steps: [
                            {
                                sequence: "0",
                                offerContainerId: section[0].steps[0].offerContainerId,
                                stepId: section[0].steps[0].stepId,
                                fields: [
                                    {
                                        name: "Number",
                                        value: section[0].steps[0].fields[0].value ? section[0].steps[0].fields[0].value : ""
                                    },
                                    {
                                        name: "IDNumber",
                                        value: section[0].steps[0].fields[1].value ? section[0].steps[0].fields[1].value : ""
                                    },
                                    {
                                        name: "Nationality",
                                        value: section[0].steps[0].fields[2].value ? section[0].steps[0].fields[2].value : ""
                                    },
                                    {
                                        name: "NewStack",
                                        value: section[0].steps[0].fields[3].value ? section[0].steps[0].fields[3].value : ""
                                    },
                                    {
                                        name: "OldSIMNumber",
                                        value: section[0].steps[0].fields[4].value ? section[0].steps[0].fields[4].value : ""
                                    },
                                    {
                                        name: "OldIMSI",
                                        value: section[0].steps[0].fields[5].value ? section[0].steps[0].fields[5].value : ""
                                    },
                                    {
                                        name: "PackageType",
                                        value: section[0].steps[0].fields[6].value ? section[0].steps[0].fields[6].value : ""
                                    },
                                    {
                                        name: "SimswapOTP",
                                        value: section[0].steps[0].fields[7].value ? section[0].steps[0].fields[7].value : ""
                                    }
                                ],
                                options: [
                                    {
                                        name: "IDName",
                                        value: section[0].steps[0].options[0].value ? section[0].steps[0].options[0].value : ""
                                    }
                                ]
                            }
                        ],
                    }

                } else {
                    numberValueRes = {
                        sectionId: "CurrentNumber",
                        steps: [
                            {
                                sequence: "0",
                                offerContainerId: section[0].steps[0].offerContainerId,
                                stepId: section[0].steps[0].stepId,
                                fields: [
                                    {
                                        name: "Number",
                                        value: section[0].steps[0].fields[0].value ? section[0].steps[0].fields[0].value : ""
                                    }
                                ]
                            }
                        ],
                    }
                }
            }
            return { ...state, requestBody: numberValueRes };

        default:
            return state;
    }
}

export default CurrentNumberReducer;